import AssignmentList from 'components/items/AssignmentList/AssignmentList'
import DocList from 'components/items/DocList/DocList'
import { useLocation } from 'react-router-dom'

type Props = {
  showOrders: boolean
  projectDrafts: ProjectTemplateList[]
  handleDocsDownload: (
    _items: Item[] | Assignment[],
    itemType: 'assignment' | 'private_doc'
  ) => void
  toggleDraftsView: () => void
  project?: Project
}

export const RenderedList = ({
  showOrders,
  projectDrafts,
  handleDocsDownload,
  toggleDraftsView,
  project,
}: Props) => {
  const location = useLocation<{ newItems?: string[] }>()

  if (!project) return null
  return showOrders ? (
    <AssignmentList
      viewType="project-items"
      project={project}
      draftsCount={projectDrafts.length}
      toggleDraftsView={toggleDraftsView}
      handleDocsDownload={items => handleDocsDownload(items, 'assignment')}
    />
  ) : (
    <DocList
      viewType="project-items"
      recentItems={location.state?.newItems}
      handleDocsDownload={items => handleDocsDownload(items, 'private_doc')}
      project={project}
    />
  )
}
